.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.helper-text {
  --form-field-label-width: 223px;

  gz-chips-generator-input {
    --form-field-with-floating-max-width: 453px;
    --chip-list-width: 453px;

    margin-bottom: calc(2 * var(--spacer));

    &::part(footer) {
      height: fit-content;
    }
  }
}

gz-policy-panel-antimalware-on-access-unix-paths-table {
  margin-top: -30px; // remove extra space
  margin-bottom: 120px;
}

#antimalware-on-access-scanning-profile-field {
  gz-text {
    margin-bottom: 8px;
  }
}

#antimalware-on-access-settings-general-archives-depth-field {
  gz-dropdown {
    --form-field-input-width: 160px;
  }
}
